export const BASE_URL=process.env.NODE_ENV == 'development' ? 'http://localhost:3255/api/v1/' : "https://mediasea.net/api/v1/"
export const CLIENT_REF="9GhR2oPcA1bQsJzW5tM6fXvYhZkL7pS0uV3y"
export const ACCESS_TOKEN = localStorage.getItem('token') || null;